import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { WidgetsService } from "./widgets.service";
import { WidgetsNoneModel } from "src/app/models/widgets/widgets-none.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "./widgets-metadata.service";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";
import { Event, NavigationEnd, Router } from "@angular/router";
import { QuestionEditorService } from "./question-editor.service";

@Injectable({
  providedIn: 'root'
})
export class WidgetsSelectionService {
  // Globally store the selected item
  // FUTURE: Multiple selection
  private readonly _selectedWidget = new BehaviorSubject<WidgetsAbstract>(new WidgetsNoneModel());
  // eslint-disable-next-line
  public readonly selectedWidget$ = this._selectedWidget.asObservable();

  // private currentRoute;

  constructor(private widgetsService: WidgetsService,
    private qeService: QuestionEditorService,
    private widgetsMetadataService: WidgetsMetadataService,
    private router: Router,
    private logger: Logger) {
/*       this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
            this.currentRoute = event.url;
        }
      }) */;
  }

  get selected(): WidgetsAbstract {
    return this._selectedWidget.getValue();
  }

  /**
   *
   */
  public async select(widget: WidgetsAbstract) {
    // Unselect all
    await this.unselectAll();
    // Select this
    widget.isSelected = true;

    // Inform interested parties...
    this._selectedWidget.next(widget);
    this.widgetsMetadataService.showMetadata(widget);
  }

  /**
   * Toggles the selection state and informs interested parties
   *
   * @param widget
   */
  public async toggleSelection(widget: WidgetsAbstract) {
    try {
      if (widget.isSelected) {
        widget.isSelected = false;
        // this.tempData.isSelected = false;
      } else {
        // Deselect all other nodes
        await this.unselectAll();
        widget.isSelected = true;

        // Inform interested parties...
        this._selectedWidget.next(widget);
        this.widgetsMetadataService.showMetadata(widget);
      }
    } catch (error) {
      this.logger.warn('toggleSelection Error: ' + error);
    }
  }

  /**
   * Unselect all Widgets*Model in the tree.
   *
   * @warning No widget will be selected after execution
   * @returns
   */
   public async unselectAll(): Promise<void> {
    // If we are in Question Editor, parent of widget is a question, and question is root
    if (this.router.url.includes("/builder/question-editor")) {
      // Question Editor: Unselect siblings
      return this.unselect(this.qeService.root);
    }
    return this.unselect(this.widgetsService.getLayoutRoot());
  }

  /**
   * Unselect node recursively
   *
   * @param widgetParent
   * @returns true if widget with specified uuid is of specified type
   */
  private async unselect(widgetParent: WidgetsAbstract): Promise<void> {
    if (widgetParent.isSelected) {
      // Selection triggers tree modification
      this.widgetsService.setLayoutTouched();
      widgetParent.isSelected = false;
    }

    if (widgetParent instanceof WidgetsContainerAbstract) {
      const model = widgetParent as WidgetsContainerAbstract;
      model.children.forEach((childWidget) => {
        this.unselect(childWidget);
      });
    }
    return;
  }
}
